import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {startCase} from "lodash";

export declare interface VOData {
  readonly rows: any[];
  readonly columns: any[];
}

declare const VOTableParser: any;
const voTableParser = new VOTableParser();

@Injectable({
  providedIn: 'root'
})
export class AsaxVoService {
  private readonly serviceIdGenerator = serviceIdGenerator();
  private readonly colorGenerator = colorGenerator();

  private readonly voServiceGeneratedSubject = new Subject<any>();
  private readonly voServiceRemovedSubject = new Subject<string>();
  private readonly activeTabIdSubject = new Subject<string>();

  constructor() {
    const id = this.serviceIdGenerator.next().value as string;
    const color = this.colorGenerator.next().value as string;
  }

  generateVoService(name: string, url: string) {
    const loadFileCallback = (voTableParser: any) => {
      const nbResources = voTableParser.getNbResourcesInFile();

      let rows: any[] = [];
      let columns: any[] = [];

      for (let i = 0; i < nbResources; i++) {
        voTableParser.selectResource(i);
        const nbTablesInResource = voTableParser.getCurrentResourceNbTables();

        for (let j = 0; j < nbTablesInResource; j++) {
          voTableParser.selectTable(j);
          const currentTableFields = voTableParser.getCurrentTableFields();
          const currentTableData = voTableParser.getCurrentTableData();

          columns = currentTableFields.map(({name, ucd, description}) => (
            {
              id: name,
              name: startCase(name),
              prop: name,
              ucd: ucd,
              description: description?.text || description
            }));

          rows = currentTableData.map(row => {
            const json = {};

            for (const [i, value] of row.entries()) {
              const prop = currentTableFields[i].name;
              json[prop] = value;
            }

            return json;
          });
        }
      }

      voTableParser.cleanMemory();

      const id = this.serviceIdGenerator.next().value as string;
      const color = this.colorGenerator.next().value as string;
      const footprints: string[] = rows.map(row => (row?.stc_s || row?.s_region));

      this.voServiceGeneratedSubject.next({id, name, color, rows, columns, footprints});
    }

    voTableParser.setCallbackFunctions(loadFileCallback)
    voTableParser.loadFileAsynchronous(url);
  }

  voServiceGenerated(): Observable<any> {
    return this.voServiceGeneratedSubject.asObservable();
  }

  removeVoService(id: string): void {
    this.voServiceRemovedSubject.next(id);
  }

  getVoServiceRemoved(): Observable<string> {
    return this.voServiceRemovedSubject.asObservable();
  }

  setActiveTabId(activeTabId: string): void {
    this.activeTabIdSubject.next(activeTabId);
  }

  getActiveTab(): Observable<string> {
    return this.activeTabIdSubject.asObservable();
  }
}

function* serviceIdGenerator() {
  let index = 0;

  while (true) {
    yield `vo-service-${index}`;
    index++;
  }
}

function* colorGenerator() {
  const letters = '0123456789ABCDEF';

  while (true) {
    let color = '#';

    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }

    yield color;
  }
}

